import { Font } from './Font';

export const getFontFamily = (font: Font = Font.ROBOTO): string => font;
